import React, { useState } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

import { useTheme } from "@mui/material/styles";
import makeStyles from "@mui/styles/makeStyles";
import withStyles from "@mui/styles/withStyles";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";

import UploadNow from "./UploadNow";
import TakePhoto from "./TakePhoto";
import AddAPhotoIcon from "@mui/icons-material/AddAPhoto";
import AddPhotoAlternateIcon from "@mui/icons-material/AddPhotoAlternate";
import CloseIcon from "@mui/icons-material/Close";
import useMediaQuery from "@mui/material/useMediaQuery";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

const useStyles = makeStyles((theme) => ({
  labelToBtn: {
    backgroundColor: "#1c355e",
    color: "#fff",
    cursor: "pointer",
    outline: 0,
    border: 0,
    margin: 0,
    justifyContent: "center",
    verticalAlign: "middle",
    font: "400 13.3333px Arial",
    lineHeight: 1.75,
    letterSpacing: "0.02857em",
    textTransform: "uppercase",
    padding: "10px 16px",
    borderRadius: 4,
    "&:hover": {
      backgroundColor: "#132541",
      boxShadow:
        "0px 2px 4px -1px rgb(0 0 0 / 20%), 0px 4px 5px 0px rgb(0 0 0 / 14%), 0px 1px 10px 0px rgb(0 0 0 / 12%)",
    },
  },
  tooltipPic: {
    width: 240,
    height: 240,
  },
  mainGrids: {
    [theme.breakpoints.up("sm")]: {
      padding: theme.spacing(4),
    },
    [theme.breakpoints.down("sm")]: {
      paddingTop: theme.spacing(1),
      paddingRight: theme.spacing(1),
      paddingBottom: theme.spacing(2),
    },
  },
  toolbar: theme.mixins.toolbar,
  tabBar: { backgroundColor: theme.palette.background.paper },
  actionButton: {
    backgroundColor: "#76BC21",
    "&:hover": {
      backgroundColor: "#edae49",
    },
    color: "white",
    marginTop: 5,
    fontWeight: 600,
  },
  tabButton: {
    [theme.breakpoints.up("sm")]: {
      paddingBottom: "20px",
      paddingLeft: "20px",
    },
    [theme.breakpoints.down("sm")]: {
      paddingBottom: "10px",
      textAlign: "center",
    },
  },
  headerGrid: {
    [theme.breakpoints.up("sm")]: { paddingTop: 10, paddingBottom: 20 },
    [theme.breakpoints.down("sm")]: { paddingTop: 10, paddingBottom: 10 },
  },
}));

const CustomButton = withStyles({
  root: {
    minWidth: 10,
    borderRadius: 5,
    backgroundColor: "#d1495b",
    color: "#fff",
    "&:hover": {
      backgroundColor: "#d1495b",
    },
  },
})(Button);

function Upload({
  selectedUploadTypeID,
  selectedUploadName,
  handleClose,
  handleUploadDocument,
  isSignNowPageStyle,
}) {
  const classes = useStyles();
  const { t } = useTranslation();
  const [showComponent, setShowComponent] = useState("");
  const theme = useTheme();
  const isXtraSmall = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Grid container item className={classes.mainGrids} xs={12} sm={9} sx={{ margin:isSignNowPageStyle?"auto":"" }}>
      <Grid
        container
        item
        direction="row"
        justifyContent="flex-end"
        className={classes.headerGrid}
        xs={12}
        sm={9}
        sx={{ margin:isSignNowPageStyle?"auto":"" }}
      >
        <Grid item style={{ paddingBottom: 20 }}>
          <CustomButton
            variant="contained"
            startIcon={
              <CloseIcon style={{ fontSize: "1.5em", marginLeft: 13 }} />
            }
            style={{ width: 36, height: 36 }}
            onClick={() => handleClose()}
          />
        </Grid>
        <Grid
          container
          item
          direction={isXtraSmall ? "column" : "row"}
          justifyContent={isXtraSmall ? "flex-start" : "center"}
        >
          <Grid item className={classes.tabButton}>
            <Button
              size="medium"
              variant="contained"
              color="primary"
              startIcon={<AddPhotoAlternateIcon style={{ fontSize: "3em" }} />}
              style={{ width: 200, height: 50 }}
              onClick={() => setShowComponent("UploadNow")}
            >
              {t("documents.fileUpload")}
            </Button>
          </Grid>
          <Grid item className={classes.tabButton}>
            <Button
              size="medium"
              variant="contained"
              color="primary"
              startIcon={<AddAPhotoIcon style={{ fontSize: "3em" }} />}
              style={{ width: 200, height: 50 }}
              onClick={() => setShowComponent("TakePhoto")}
            >
              {t("documents.photoUpload")}
            </Button>
          </Grid>
        </Grid>
      </Grid>

      <Grid
        container
        item
        direction="row"
        justifyContent="center"
        className={classes.headerGrid}
        xs={12}
        sm={9}
        sx={{ margin:isSignNowPageStyle?"auto":"" }}
      >
        {showComponent === "UploadNow" ? (
          <Grid container item direction="column" alignItems="center">
            <UploadNow
              selectedUploadTypeID={selectedUploadTypeID}
              selectedUploadName={selectedUploadName}
              handleUploadDocument={handleUploadDocument}
            ></UploadNow>
          </Grid>
        ) : showComponent === "TakePhoto" ? (
          <Grid
            container
            direction="column"
            alignItems="center"
            //style={{ maxWidth: 800 }}
          >
            <TakePhoto
              selectedUploadTypeID={selectedUploadTypeID}
              selectedUploadName={selectedUploadName}
              handleUploadDocument={handleUploadDocument}
            ></TakePhoto>
          </Grid>
        ) : (
          <></>
        )}
      </Grid>
    </Grid>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

Upload.propTypes = {
  selectedUploadTypeID: PropTypes.number,
  selectedUploadName: PropTypes.string,
  handleClose: PropTypes.func.isRequired,
  handleUploadDocument: PropTypes.func.isRequired,
  isSignNowPageStyle: PropTypes.bool,
};

export default Upload;
